import React from 'react'

const ProductPriceList = () => {
  return (
    <div className='mx-auto p-4'>
      ProductPriceList
    </div>
  )
}

export default ProductPriceList
